export default function load() {
  return new Promise((resolve, reject) => {
    let el,
      id = 'wechat-sdk',
      container = document.getElementsByTagName('script')[0];
    if (document.getElementById(id)) {
      resolve(true);
    }
    el = document.createElement('script');
    el.id = id;
    el.async = true;
    el.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
    container.parentNode.insertBefore(el, container);
    el.addEventListener('load', () => {
      resolve(true);
    });
    el.addEventListener('error', reject);
  });
}
